import MojitoCore from 'mojito/core';
import BonusHistory from './view/index.js';
import MojitoServices from 'mojito/services';
import { connect } from 'react-redux';

const { BONUS_FILTER } = MojitoServices.Bonus.types;
const { actions: campaignActions, selectors: campaignSelectors } = MojitoServices.BonusCampaign;
const { selectHistoricBonusCampaigns, selectCampaignsPending } = campaignSelectors;
const { actions: userBonusesActions, selectors: userBonusesSelectors } = MojitoServices.UserBonuses;
const { selectHistoricFreeBets, selectIsFetchingHistoric, selectHistoricOddsBoosts } =
    userBonusesSelectors;
const { selectCurrency } = MojitoServices.UserInfo.selectors;
const { UIViewImplementation } = MojitoCore.Presentation;

class BonusHistoryController extends UIViewImplementation {
    constructor(props) {
        super(props);

        this.state = {
            freeBets: [],
            currencyCode: undefined,
        };
    }

    componentDidMount() {
        const { showPrewager, dispatch } = this.props;
        dispatch(userBonusesActions.fetchHistoricUserBonuses());
        if (showPrewager) {
            dispatch(campaignActions.getCampaigns(BONUS_FILTER.HISTORIC));
        }
    }

    isLoading() {
        return this.props.isBonusCampaignPending || this.props.isFetchingHistoricUserBonuses;
    }

    render() {
        return (
            <BonusHistory
                campaigns={this.props.historicBonusCampaigns}
                freeBets={this.props.freeBets}
                oddsBoosts={this.props.oddsBoosts}
                currencyCode={this.props.currencyCode}
                config={this.config.view}
                bonusHistoryLoading={this.isLoading()}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const bonusCampaigns = selectHistoricBonusCampaigns(state);
    const campaignsPending = ownProps.showPrewager ? selectCampaignsPending(state) : false;

    const freeBets = selectHistoricFreeBets(state);
    const oddsBoosts = selectHistoricOddsBoosts(state);
    const bonusesPending = selectIsFetchingHistoric(state);

    return {
        historicBonusCampaigns: bonusCampaigns,
        isBonusCampaignPending: campaignsPending && !bonusCampaigns.length,
        currencyCode: selectCurrency(state),
        freeBets: freeBets,
        oddsBoosts: oddsBoosts,
        isFetchingHistoricUserBonuses: bonusesPending && !freeBets.length && !oddsBoosts.length,
    };
};

export default connect(mapStateToProps)(BonusHistoryController);
